import React from 'react';
import { Row, Col } from 'antd';

const CFooter = () => {
  const items = [
    { title: 'Support' },
    { title: 'Terms & Conditions' },
    { title: 'Privacy Policy' }
  ];

  return (
    <Row align="middle" justify="space-between" style={{ minHeight: '100%', padding: '0px 40px' }}>
      <Col align="start" span={8}>
        {`Powered By `}
        <a href="https://noxtton.com" rel="noopener noreferrer" target="_blank">
          <strong style={{ color: 'black' }}>Noxtton</strong>
        </a>
      </Col>
      <Col span={16}>
        <Row gutter="64" justify="end">
          {items.map(({ title }, index) => {
            return <Col key={index}>{title}</Col>;
          })}
        </Row>
      </Col>
    </Row>
  );
};

export default CFooter;
